/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _AuthAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").checkTeams>}  */
  checkTeams: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/teams`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").sendCode>}  */
  sendCode: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/sendCode`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").getMembers>}  */
  getMembers: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/members`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").getRegistrationMembers>}  */
  getRegistrationMembers: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/registrationMembers`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").loginWithCode>}  */
  loginWithCode: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/loginWithCode`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").loginWithCodeEvent>}  */
  loginWithCodeEvent: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/loginWithCodeEvent`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").loginWithRegistrationNumber>}  */
  loginWithRegistrationNumber: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/loginWithRegistrationNumber`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").login>}  */
  login: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/login`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").refreshToken>}  */
  refreshToken: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/auth/refresh`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/auth/auth.js").getCurrentUser>}  */
  getCurrentUser: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/auth/me`,
      { method: "GET", query }
    ]
  ),
};
export { _AuthAPI as AuthAPI };
